function Blog() {
    return (
      <div>
        <h1>Blog & News</h1>
        <p>Latest news and updates.</p>
      </div>
    );
  }
  
  export default Blog;